import React from 'react'
import PropTypes from 'prop-types'

// Component
function IconArrowDown({ width, height, color }) {
  return (
    <svg
      stroke="currentColor"
      width={width}
      height={height}
      fill="none"
      strokeWidth="2"
      viewBox="0 0 24 24"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
    >
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  )
}

IconArrowDown.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  color: PropTypes.string,
}

IconArrowDown.defaultProps = {
  width: '18px',
  height: '18px',
  color: '#222222',
}

export default IconArrowDown
